import omit from 'lodash.omit';
import uniqBy from 'lodash.uniqby';

import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  entityJurisdictions: [],
  taxCodes: [],
  clientTransactionTypes: [],
  continuousClientTransactionTypes: {},
  taxCodesWithTransactionTypes: {
    results: [],
    isLoading: true,
  },
  taxCodeWizardMap: {},
  searchQuery: undefined,
  rates: [],
  error: null,
  entityJurisdictionsCount: 0,
};

export default reducerFactory(initialState, {
  [types.CLEAR_CLIENT_TRANSACTION_TYPES]: state => ({
    ...state,
    clientTransactionTypes: [],
    error: null,
  }),
  [types.SAVE_CLIENT_TAX_CODES]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.SAVE_CLIENT_TAX_CODES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    clientTransactionTypes: response?.clientTransactionTypes,
  }),
  [types.SAVE_CLIENT_TAX_CODES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.GET_TAX_CODES_JURISDICTIONS_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.GET_TAX_CODES_JURISDICTIONS_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    entityJurisdictions: response.results,
    entityJurisdictionsCount: response.count,
  }),
  [types.GET_TAX_CODES_JURISDICTIONS_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.GET_TAX_CODES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.GET_TAX_CODES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    taxCodes: [...response.results],
  }),
  [types.GET_TAX_CODES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.GET_TAX_CODES_RATES_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.GET_TAX_CODES_RATES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    rates: { ...response },
  }),
  [types.GET_TAX_CODES_RATES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.GET_CLIENT_TRANSACTION_TYPES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.GET_CLIENT_TRANSACTION_TYPES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    clientTransactionTypes: response.results,
  }),
  [types.GET_CLIENT_TRANSACTION_TYPES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.RESET_CLIENT_TRANSACTION_TYPES]: (state, { payload: { vatNumber } }) => ({
    ...state,
    continuousClientTransactionTypes: omit(state.continuousClientTransactionTypes, vatNumber),
  }),
  [types.SAVE_NEW_TAX_CODE_WIZARD_MAP]: (state, { payload }) => ({
    ...state,
    taxCodeWizardMap: { ...payload },
  }),
  [types.GET_TAX_CODES_WITH_TRANSACTION_TYPES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    taxCodesWithTransactionTypes: {
      results: [],
      isLoading: true,
    },
    error: null,
  }),
  [types.GET_TAX_CODES_WITH_TRANSACTION_TYPES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    taxCodesWithTransactionTypes: {
      isLoading: false,
      results: uniqBy(response.results, 'id'),
    },
  }),
  [types.GET_TAX_CODES_WITH_TRANSACTION_TYPES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
    taxCodesWithTransactionTypes: {
      results: [],
      isLoading: false,
    },
  }),
  [types.RESET_TAX_CODES_WITH_TRANSACTION_TYPES]: state => ({
    ...state,
    isLoading: false,
    taxCodesWithTransactionTypes: {
      results: [],
      isLoading: true,
    },
  }),
  [types.GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    continuousClientTransactionTypes: {
      ...state.continuousClientTransactionTypes,
      [response.id]: response.results,
    },
  }),
  [types.GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.UPDATE_TAX_CODES_SEARCH_QUERY]: (state, { payload }) => ({
    ...state,
    searchQuery: payload,
  }),
  [types.CLEAR_TAX_CODES_SEARCH_QUERY]: state => ({
    ...state,
    searchQuery: undefined,
  }),
});
